module.exports = __webpack_public_path__ + "static/media/blue-user-icon1.d0a287fe.svg";